import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface DatePickerProps {
  date?: Date;
  onDateChange?: (date: Date | undefined) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  availableDates?: Date[];
}

export function DatePicker({
  date,
  onDateChange,
  placeholder = "Pick a date",
  className,
  disabled = false,
  availableDates,
}: DatePickerProps) {
  return (
    <ReactDatePicker
      selected={date}
      onChange={(date) => onDateChange?.(date || undefined)}
      placeholderText={placeholder}
      disabled={disabled}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      dateFormat="MMMM do, yyyy"
      className={cn(
        "w-full justify-start text-left font-normal min-h-[44px] px-3 py-2 bg-white border border-slate-200 rounded-md hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent",
        !date && "text-slate-500",
        date && "text-slate-900",
        className
      )}
      calendarClassName="bg-white border border-slate-200 shadow-lg rounded-lg p-2"
      dayClassName={(date) => {
        const isToday = new Date().toDateString() === date.toDateString();
        const isSelected = date && date.toDateString() === date.toDateString();
        return cn(
          "hover:bg-slate-100 rounded transition-colors",
          isToday && "bg-blue-50 text-blue-900 font-semibold ring-1 ring-blue-200",
          isSelected && "bg-slate-900 text-white"
        );
      }}
      wrapperClassName="w-full"
      showPopperArrow={false}
      popperClassName="z-50"
    />
  );
} 